import React, { Component } from "react";
import { connect } from "react-redux";
import {
  fetchIndicators,
  fetchSupportedIndicatorVars,
  updateIndicator,
  defineIndicator,
  deleteIndicator
} from "../../actions/thunks";
import { selectCurrentOrganization } from "../../selectors";
import List from "./List";
import { onSuccess, onError } from "../../utils";
import _ from "i18n";

class Indicators extends Component {
  componentWillMount() {
    const { dispatch } = this.props;
    dispatch(fetchIndicators());
    dispatch(fetchSupportedIndicatorVars());
  }

  componentDidUpdate(prevProps, prevState) {
    const { currentOrganization, indicatorList } = prevProps;
    const { dispatch } = this.props;
    if (
      currentOrganization !== this.props.currentOrganization ||
      indicatorList.length !== this.props.indicatorList.length
    ) {
      dispatch(fetchIndicators());
      dispatch(fetchSupportedIndicatorVars());
    }
  }

  handleUpdateIndicator(indicator) {
    const { dispatch } = this.props;
    return dispatch(updateIndicator(indicator))
      .then(resp => {
        this.props.onChange(indicator);
        return (async () =>
          onSuccess(resp, {
            title: _("saveSuccess")
          }))();
      })
      .catch(err => {
        return (async () => onError(err))();
      });
  }

  handleDefineIndicator(indicator) {
    const { dispatch } = this.props;
    return dispatch(defineIndicator(indicator))
      .then(resp => {
        this.props.onChange(indicator);
        return (async () =>
          onSuccess(resp, {
            title: _("saveSuccess")
          }))();
      })
      .catch(err => {
        return (async () => onError(err))();
      });
  }

  handleDeleteIndicator(indicator) {
    const { dispatch } = this.props;
    return dispatch(deleteIndicator(indicator))
      .then(resp => {
        this.props.onChange(indicator);
        return (async () =>
          onSuccess(resp, {
            title: _("removeSuccess")
          }))();
      })
      .catch(err => {
        return (async () => onError(err))();
      });
  }

  render() {
    if (this.props.fetching || this.props.suggestions.fetching) {
      return "";
    }

    return (
      <List
        indicators={this.props.indicatorList}
        language={"fr"}
        suggestions={this.props.suggestions.items}
        current={this.props.current}
        handleUpdateIndicator={this.handleUpdateIndicator.bind(this)}
        handleDefineIndicator={this.handleDefineIndicator.bind(this)}
        handleDeleteIndicator={this.handleDeleteIndicator.bind(this)}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    fetching: state.indicators.fetching,
    fetched: state.indicators.fetched,
    indicatorList: state.indicators.items,
    suggestions: state.indicators.suggestions,
    current: state.indicators.current,
    currentOrganization: selectCurrentOrganization(state)
  };
}

export default connect(mapStateToProps)(Indicators);



// WEBPACK FOOTER //
// ./src/components/Indicator/Indicators.js